module.exports = __webpack_public_path__ + "static/meditation-d9f7aa92bec5bc3dfff21e603f1e3760.png";